import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'chaoskit/src/components';

import BaseLayout from './BaseLayout';
import { Icon } from '../components';

const ChaosEngineeringLayout = ({ children }) => (
  <BaseLayout>
    {children}
    <Button
      type="primary"
      className="chaosEngineering__cta"
      url="/chaos-engineering-guide-pdf/"
    >
      Download PDF
      <Icon className="u-ml--small" icon="arrow-right" />
    </Button>
  </BaseLayout>
);

ChaosEngineeringLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChaosEngineeringLayout;
